import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/plus.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/minus.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-down.svg';
export default {
  name: 'Accordion',
  props: {
    title: {
      type: String,
      required: true
    },
    productLine: {
      type: String,
      required: false,
      default: ''
    },
    subtitle: {
      type: String,
      default: null
    },
    url: {
      type: String,
      required: true
    },
    withChevronIcon: {
      type: Boolean,
      default: false
    },
    forceToggleFold: {
      type: Boolean,
      default: false
    },
    externalFold: {
      type: Boolean,
      default: false
    },
    titleCenter: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isFolded: !this.foldValue
    };
  },
  computed: {
    toggleCondition: function toggleCondition() {
      return !this.isFolded || this.externalFold;
    }
  },
  methods: {
    toggleFold: function toggleFold() {
      if (!this.forceToggleFold) {
        this.isFolded = !this.isFolded;
      }
    }
  }
};